/* site designer module */

import uiRouter from '@uirouter/angularjs';
import get from 'lodash/get';

import { AppShellModule } from 'components/appShell/appShell.module';
import { AppsServiceModule } from 'services/data/apps.service';
import { LaunchDarklyServiceModule } from 'services/access/launchDarkly/launchDarkly.service';
import { OnboardingServiceModule } from 'services/data/onboarding.service';
import { StoreInformationServiceModule } from 'services/data/storeInformation.service';

import './siteDesigner.scss';

export const SiteDesignerModule = angular
    .module('app.pages.siteDesigner', [
        uiRouter,
        AppShellModule,
        AppsServiceModule,
        LaunchDarklyServiceModule,
        OnboardingServiceModule,
        StoreInformationServiceModule
    ]).config(($stateProvider) => {
        'ngInject';

        $stateProvider.state('designer', {
            parent: 'auth',
            name: 'siteDesigner',
            url: '/designer',
            params: {
                gallery: '',
                addpage: ''
            },
            component: 'appShell',
            resolve: {
                title: () => { return 'Site Designer'; },
                trackingId: () => { return 'Site Designer'; },
                state: onboardingService => onboardingService.getState(),
                isNewAccount: (launchDarklyService, storeInformationService) => {
                    return storeInformationService.getStore()
                        .then(storeInformation => launchDarklyService.isNewAccount(storeInformation));
                },
                canAddPages: (launchDarklyService, isNewAccount) =>
                    launchDarklyService.getFeature('site-designer-add-page') || isNewAccount,
                src: (authTokenService, onboardingService, state, isNewAccount, canAddPages, $stateParams) => {
                    const tenantId = authTokenService.getCachedTenantId();
                    const token = authTokenService.getCachedToken();

                    const FIRST_VISIT_KEY = 'sitedesigner.firstvisit';
                    const firstVisit = isNewAccount && !get(state, `tasks.completed['${FIRST_VISIT_KEY}']`, false);

                    let paramList = [];
                    if ($stateParams.gallery || firstVisit) paramList.push('gallery=1');
                    if ($stateParams.addpage && canAddPages) paramList.push('addpage=1');

                    const params = paramList.length ? `&${paramList.join('&')}` : '';

                    if (firstVisit) onboardingService.completeTask(FIRST_VISIT_KEY);

                    return `${process.env.SITE_DESIGNER_URL}?tenantId=${tenantId}&token=${token}${params}`;
                }
            },
            data: {
                page: 'siteDesigner'
            }
        })
            .state('usersAndPermissions', {
                url: '/designer/users',
                reloadOnSearch: false,
                parent: 'auth',
                name: 'usersAndPermissions',
                component: 'appShell',
                resolve: {
                    title: () => { return 'User Management'; },
                    trackingId: () => { return 'Users Permissions'; },
                    src: (authTokenService) => {
                        const tenantId = authTokenService.getCachedTenantId();
                        const token = authTokenService.getCachedToken();

                        return `${process.env.SITE_DESIGNER_URL}?tenantId=${tenantId}&token=${token}&users=1`;
                    }
                },
                data: {
                    page: 'usersAndPermissions'
                }
            })
            .state('blockManagement', {
                url: '/designer/blocks',
                reloadOnSearch: false,
                parent: 'auth',
                name: 'blockManagement',
                component: 'appShell',
                resolve: {
                    title: () => { return 'Block Management'; },
                    trackingId: () => { return 'Block Management'; },
                    src: (authTokenService) => {
                        const tenantId = authTokenService.getCachedTenantId();
                        const token = authTokenService.getCachedToken();

                        return `${process.env.SITE_DESIGNER_URL}?tenantId=${tenantId}&token=${token}&blocks=1`;
                    }
                },
                data: {
                    page: 'blockManagement'
                }
            })
            .state('menuManagement', {
                url: '/designer/menus',
                reloadOnSearch: false,
                parent: 'auth',
                name: 'menuManagement',
                component: 'appShell',
                resolve: {
                    title: () => { return 'Menu Management'; },
                    trackingId: () => { return 'Menu Management'; },
                    src: (authTokenService) => {
                        const tenantId = authTokenService.getCachedTenantId();
                        const token = authTokenService.getCachedToken();

                        return `${process.env.SITE_DESIGNER_URL}?tenantId=${tenantId}&token=${token}&menus=1`;
                    }
                },
                data: {
                    page: 'menuManagement'
                }
            });
    }).name;



// WEBPACK FOOTER //
// ./src/app/pages/siteDesigner/siteDesigner.module.js